/**
 * Прямое соединение или ретранслятор (изменение v1.14, настройка `calls_p2p`).
 *
 * При прямом соединении (peer-to-peer) собеседник видит IP-адрес. Поэтому, как в Telegram,
 * напрямую звонок идёт только тем, кому это разрешено настройкой: всем, только контактам или
 * никому. Остальным — через TURN-ретранслятор, и адрес скрыт.
 */
import type { Settings } from '@shared/api/types'

type P2pPolicy = Settings['calls_p2p']

/** Нужен ли звонку только ретранслятор (`iceTransportPolicy: 'relay'`). */
export function relayRequired(policy: P2pPolicy | null | undefined, peerIsContact: boolean): boolean {
  switch (policy ?? 'contacts') {
    case 'everyone':
      return false
    case 'nobody':
      return true
    default:
      return !peerIsContact
  }
}
